<p-table
  [scrollable]="true"
  styleClass="p-datatable-sm"
  [value]="_prw.rows">

  <!--HEADER-->
  <ng-template pTemplate="header">

    <tr>
      <th [style.width.px]="250">Prestations</th>
      <th *ngIf="displayRegime" [style.width.px]="100">Régimes</th>
      <ng-container *ngFor="let col of _prw.cols">
        <th [style.width.px]="colWidth">
          <div class="no-overflow" >
                        <span style="font-weight:normal;font-size:12px"
                              class="mg-r-5">{{col | date:'EEE d LLL'}}  </span>
          </div>
        </th>
      </ng-container>
    </tr>
  </ng-template>

  <!--BODY-->
  <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
    <tr>

      <td class="no-overflow" [style.width.px]="250" [title]="rowData.cmcLibelle">
        {{rowData.cmcLibelle}}
      </td>
      <td *ngIf="displayRegime" class="no-overflow" [style.width.px]="100" [title]="rowData.libelle">
        {{rowData.libelle}}
      </td>

      <!--CELLULES-->
      <ng-container *ngFor="let col of _prw.cols">
        <ng-container *ngTemplateOutlet="tplCell;context:{cell:getCell(_prw,rowData,col)}"></ng-container>
      </ng-container>
    </tr>

  </ng-template>

</p-table>

<ng-template #tplCell let-cell="cell">

  <ng-container *ngIf="!utils.isNullOrEmpty(cell)">
    <td [style.width.px]="colWidth"
        [class.cell-invoice]="cell.ligneFacturationId !== 0"
        [class.cell-saisie-effectifs]="cell.statutMenuCode === STATUTS_MENUS.SAISIE_EFFECTIFS && selectedCell!=cell && cell.ligneFacturationId === 0"
        [class.cell-creation-menus]="cell.statutMenuCode === STATUTS_MENUS.CREATION_MENUS && selectedCell!=cell && cell.gcomCmcRepasPlcId !== 0"
        [class.cell-selected]="selectedCell === cell"
        [class.cell-import-effectifs]="selectedCell!=cell && cell.gcomCmcrPlcId !== 0"
        class=" cursor text-right" (click)="showRepas(cell)">

      <ng-container [ngSwitch]="typeEffectif">

        <ng-container *ngSwitchCase="EffectifMode.Prevision">
          <!--          (focus)="showRepas(cell,$event)"-->
          <input pKeyFilter="pint"
                 [hidden]="+cell.gcomCmcrPlcId !== 0"
                 type="number"
                 [class.disable]="isEffectifInputDisabled(cell)"
                 min="0"
                 [readOnly]="cell.ligneFacturationId !== 0"
                 (focusin)="showRepas(cell)"
                 [ngModel]="cell.effectifPrevisionnel"
                 (ngModelChange)="changeEffectif($event,cell,'effectifPrevisionnel')"
                 (click)="$event.stopPropagation()"
                 class="cell text-right bold">
        </ng-container>

        <ng-container *ngSwitchCase="EffectifMode.Fabrication">
          <input pInputText pKeyFilter="pint"
                 [class.disable]="isEffectifInputDisabled(cell)"
                 [hidden]="+cell.gcomCmcrPlcId !== 0"
                 min="0"
                 [readOnly]="cell.ligneFacturationId !== 0"
                 (focusin)="showRepas(cell)"
                 [ngModel]="cell.effectifFabrication"
                 (ngModelChange)="changeEffectif($event,cell,'effectifFabrication')"
                 (click)="$event.stopPropagation()"
                 class=" cell text-right bold">
        </ng-container>

        <ng-container *ngSwitchCase="EffectifMode.Facturation">
          <input pInputText pKeyFilter="pint"
                 min="0"
                 [hidden]="+cell.gcomCmcrPlcId !== 0"
                 [readOnly]="cell.ligneFacturationId !== 0"
                 (focusin)="showRepas(cell)"
                 [class.disable]="isEffectifInputDisabled(cell)"
                 [ngModel]="cell.effectifFacture"
                 (click)="$event.stopPropagation()"
                 (ngModelChange)="changeEffectif($event,cell,'effectifFacture')"
                 class=" cell text-right bold">
        </ng-container>

      </ng-container>
    </td>
  </ng-container>

  <ng-container *ngIf="utils.isNullOrEmpty(cell)">
    <td [class.cell-selected]="false">
      <span>&nbsp;</span>
    </td>
  </ng-container>

</ng-template>
